import { atom } from "jotai";

export const selectedShippingMethodAtom = atom<string | undefined>(undefined);
